import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CarruseladminComponent } from './carruseladmin.component';
import { ProductcardModule } from '../productcard/productcard.module';
import { MatNativeDateModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { CarruselModule } from '../carrusel/carrusel.module';



@NgModule({
  declarations: [
    CarruseladminComponent
  ],
  entryComponents: [
    CarruseladminComponent
  ],
  exports: [
    CarruseladminComponent
  ],
  imports: [
    CommonModule,
    CarruselModule,
    ProductcardModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatNativeDateModule,
  ]
})
export class CarruseladminModule { }
